module.exports = __webpack_public_path__ + "static/img/thankyou@2x.7f5189f9.png";